// Array of pages to load asynchronously
const LoadedPages = [];
//console.log((window.Template);
if (window.Template.is('homepage')) {
    LoadedPages.push(import('./Home.js'));
}

if (window.Template.is('contact')) {
    LoadedPages.push(import('./Contact.js'));
}

if (window.Template.is('services')) {
    LoadedPages.push(import('./Services.js'));
}

if (window.Template.is('blog')) {
    LoadedPages.push(import('./Blog.js'));
}

export default Promise.all(LoadedPages);
